var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContractAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49997 19.5C1.80128 19.5 1.20993 19.258 0.72595 18.774C0.241983 18.29 0 17.6987 0 17V14.1154H3V0.5H17V9.00383C16.75 8.95254 16.4974 8.93876 16.2423 8.96248C15.9871 8.98619 15.7397 9.04548 15.5 9.14035V1.99998H4.49997V14.1154H10.0576L8.55768 15.6153H1.49997V17C1.49997 17.2833 1.59581 17.5208 1.78747 17.7125C1.97914 17.9041 2.21664 18 2.49997 18H8.30765V19.5H2.49997ZM10.5 19.5V16.7673L14.7038 12.5635L15.5577 13.4077L11.6922 17.2577V18.3077H12.7422L16.6077 14.4577L17.4461 15.2961L13.2422 19.5H10.5ZM17.4461 15.2961L14.7038 12.5635L15.8865 11.3808C16.057 11.2167 16.2695 11.1346 16.524 11.1346C16.7785 11.1346 16.9878 11.2167 17.1519 11.3808L18.6288 12.8577C18.7929 13.0218 18.8749 13.231 18.8749 13.4855C18.8749 13.74 18.7929 13.9525 18.6288 14.123L17.4461 15.2961ZM5.6923 6.69225V5.1923H14.3077V6.69225H5.6923ZM5.6923 9.57688V8.0769H14.3077V9.57688H5.6923Z",
    fill: "#B6B6B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractAdd);
export default __webpack_public_path__ + "static/media/contract_add.4a8d3b6683d0baf4adfe2bd7ea5bb338.svg";
export { ForwardRef as ReactComponent };